import { getFrameworkImagePathWithAPIKey } from "../../../services/b2b-frameworks-apiService";
import { useQuery } from "@tanstack/react-query";
import useB2BTranslation from "../../b2b-common/hooks/useB2BTranslation";

const useFwImagePath = (frameworkSuite, frameworkId, locale = null) => {
    const { t } = useB2BTranslation('b2b-frameworks');

    const fetchImagePath = async (frameworkSuite, frameworkId, locale) => {
        try {
            const imagePath = await getFrameworkImagePathWithAPIKey(frameworkSuite, frameworkId, locale);
            return imagePath;
        } catch (error) {
            console.error('Error fetching framework image path:', error);
        }
    };

    const { data: imagePath } = useQuery({
        queryKey: ['fwImagePath', frameworkSuite, frameworkId, locale],
        queryFn: () => fetchImagePath(frameworkSuite, frameworkId, locale),
    });

    return imagePath;
};

export default useFwImagePath;
